import { Vue, Component, Watch } from 'vue-property-decorator'
import DiseasesPage from '~/components/page/diseases/DiseasesPage'
import s from '~/utils/s'
import SeoHelper from '~/utils/seoHelper'

@Component({
  async fetch ({ route, store }) {
    await s(store).diseasesPage.loadData(route)
    await new SeoHelper(route.name ?? '', store).load()
  }
})
export default class extends Vue {
  @Watch('$route.query')
  async onQueryChanged () {
    s(this.$store).diseasesPage.enableLoader()
    await s(this.$store).diseasesPage.loadItems()
  }

  mounted () {
    const elem = document.querySelector('.diseases-page__row')
    if (elem) {
      const offset = window.scrollY + elem.getBoundingClientRect().top
      setTimeout(() => window.scrollTo({ top: offset - 100, left: 0, behavior: 'smooth' }), 500)
    }
  }

  render () {
    return (
      <DiseasesPage />
    )
  }
}
